import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { auth } from './services/firebase.service'; // auth firebase config
import { Container } from './styles/reset'; // reset styling
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import Auth from './pages/Auth/Auth'; // auth components
import Workout from './pages/Workout/Workout'; // workout components

function App() {
  const [isLogged, setIsLogged] = useState(false);

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      user ? setIsLogged(true) : setIsLogged(false)
    })
  }, []);
  
  return (
    <Container className="App">
      {
        isLogged
        ? (<>
            <Header />
              <Routes>
                <Route path='/' element={<Workout />}/>
              </Routes>
            <Footer />
          </>)
        : (<><Auth /></>)
      }
    </Container>
  );
}

export default App;
